
import React from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { FaTools, FaLaptopCode, FaUsersCog } from 'react-icons/fa'; 
import { Link } from 'react-router-dom';
import './Services.css'
const OurServices = () => {
  return (
    <section className="nossos-servicos-section1">
      <h2 className="nossos-servicos-title1">Our Services</h2>

      <Container>
        <Row>
          {/* Coluna 1: Manutenção Predial */}
          <Col md={4} className="nossos-servicos-column1">
            <div className="nossos-servicos-card1">
              <h3 className="nossos-servicos-card-title1">
                <FaTools className="icon-style1" /> Building Maintenance
              </h3>
              <p style={{ color: '#555' }}>
    We guarantee the functionality and preservation of your facilities, eliminating risks and extending the lifespan of your assets, offering services such as: <br />
    
    <ul style={{textAlign:'left'}} className='services-list1'>
        <li>Management and Maintenance of Water Treatment Plants (ETA)</li>
        <li>Implementation of Plumbing Systems</li>
        <li>Maintenance and Installation of Medium and High Voltage Electrical Systems</li>
        <li>Gate Assembly</li>
        <li>Gate Repair</li>
        <li>Gardening Services</li>
        <li>HVAC Installation and Maintenance</li>
        <li>Gardening Services</li>
        <li>Masonry and Interior Finishing</li>
        <li>Installation and Testing of Fire Detection and Suppression Systems</li>
        <li>Swimming Pool Maintenance</li>
        <li>Metalworking</li>
    </ul>
</p>

             <Link to="/Building"><Button className="nossos-servicos-button1">View Projects</Button></Link>
            </div>
          </Col>

          {/* Coluna 2: Tecnologia de Informação */}
          <Col md={4} className="nossos-servicos-column1">
            <div className="nossos-servicos-card1">
              <h3 className="nossos-servicos-card-title1">
                <FaLaptopCode className="icon-style1" /> Information Technology
              </h3>
              <p style={{ color: '#555' }}>
    We transform processes with tailored digital solutions, increasing your productivity and competitiveness, offering services such as:
    <ul className='services-list1' style={{textAlign:'left'}}>
        <li>Electronic Security</li>
        <li>CCTV Video Surveillance System</li>
        <li>Speed Monitoring System (RADAR)</li>
        <li>Installation and Maintenance of IT and Telecommunications Networks</li>
        <li>Installation of RFID Access Control and Magnetic Locks</li>
        <li>Renewable Energy Services</li>
        <li>Installation of Architecture and Design Software</li>
    </ul>
</p>

              <Link to="/InformationTechnology"> <Button className="nossos-servicos-button1">View Projects</Button></Link>
            </div>
          </Col>

          {/* Coluna 3: Consultoria */}
          <Col md={4} className="nossos-servicos-column1">
            <div className="nossos-servicos-card1">
              <h3 className="nossos-servicos-card-title1">
                <FaUsersCog className="icon-style1" /> Consultancy
              </h3>
              <p style={{ color: '#555' }}>
    We offer customized strategies to drive growth and efficiency for your business. We provide consulting in Building Maintenance Services and Information Technology.
</p>

              <Button className="nossos-servicos-button1">View Projects</Button>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default OurServices;
